// Maps a /v1/api/digital-profiles/top item onto ContractorCard's props.
// Unlike /v2/api/lead-gen/profiles (find-contractors' own mapper, see
// mapContractorProfile.js), this endpoint does carry an org name
// (`orgDetails.name`) distinct from the contractor's own name, so the
// business-vs-individual card styling (ContractorCard's `businessName`
// branch) is real here, not dropped like it is there — there's just no
// separate org logo field, so `businessLogo` stays unset either way.
export function mapContractorMatch(contractor) {
  const location = [contractor.orgDetails?.locality, contractor.orgDetails?.city]
    .filter(Boolean)
    .join(", ") || null;

  return {
    profileId: contractor.contractorProfileId ?? null,
    href: contractor.contractorProfileId
      ? `/digital-profile/${contractor.contractorProfileId}?isLeadGenProfile=true`
      : undefined,
    coverImage: contractor.latestImages?.[0] ?? null,
    photosCount: contractor.totalPhotosCount ?? null,
    businessName: contractor.orgDetails?.name ?? null,
    contractorName: contractor.contractorName,
    contractorImage: contractor.profilePicture ?? null,
    location,
    workExpYears: contractor.workExperienceV2 ?? null,
    projectsCount: contractor.projectCount ?? null,
    labourCost: contractor.avgLabourCost ?? null,
  };
}
